<template>
  <v-row>
    <v-col
        v-for="image in images"
        :key="image.src"
        class="d-flex child-flex"
        cols="2"
    >
      <v-img
          :src="image.imageSrc"
          lazy-src="https://picsum.photos/10/6?image=15"
          aspect-ratio="2"
          class="grey lighten-2 pointer"
          @click="$emit('updateMediaSrc', image)"
      >
        <template #placeholder>
          <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
          >
            <v-progress-circular
                indeterminate
                color="grey lighten-5"
            />
          </v-row>
        </template>
      </v-img>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'SelectFromGallery',
  props: {
    images: []
  }
}
</script>
<style scoped lang="scss">

.cropper-container img {
  max-width: 100%;
  margin-top: 20px;
}
</style>
